import React from 'react'
import CardItem from './CardItem'
import './Cards.css';
import { useNavigate } from 'react-router-dom';
import { getCountryName } from '../../../utils/locationUtils';

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

function Cards({ activities }) {
    const navigate = useNavigate();

    if (!activities || activities.length === 0) {
        return null;
    }

    // Helper function to get the primary image
    const getPrimaryImage = (activity) => {
        if (activity.images && activity.images.length > 0) {
            return activity.images[0];
        }
        return activity.image || '/default-activity.jpg';
    };

    // Helper function to format location
    const formatLocation = (activity) => {
        const parts = [];
        if (activity.location) parts.push(activity.location);
        if (activity.state) parts.push(activity.state);
        if (activity.country) parts.push(getCountryName(activity.country));
        return parts.join(', ');
    };

    return (
        <div className='cards'>
            <div className='cards__container'>
                <div className='cards__wrapper'>
                    {activities.map((activity, index) => (
                        <div 
                            key={activity.id || index} 
                            className='cards__item'
                            onClick={() => navigate(`/activities/${activity.id}`)}
                        >
                            <CardItem
                                src={getPrimaryImage(activity)}
                                text={activity.description}
                                label={activity.category}
                                title={activity.title}
                                date={activity.date}
                                location={formatLocation(activity)}
                            />
                        </div>
                    ))}
                </div>
                <div className="cards__more">
                    <button 
                        className="cards__more-btn"
                        onClick={() => navigate('/activities')}
                    >
                        View All Activities
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Cards
